import React, { useEffect, useState } from "react";
import BlogPosts from "./common/blog-posts";
import Pagination from "@material-ui/lab/Pagination";
import BlogCategory from "./common/blogCategories";
import BlogShortPosts from "./common/blogShortPosts";
import BlogService from "../../../services/blogService";
import { paginate } from "../../../utils/paginate";

const BlogBase = () => {
  const [category, setCategory] = useState([]);
  const [blog, setBlog] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(4);

  useEffect(() => {
    let blog = BlogService.getBlog();
    setBlog(blog);
    let category = BlogService.getBlogCategory();
    setCategory(category);
  }, []);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const getPageData = () => {
    const paginateBlog = paginate(blog, currentPage, pageSize);

    const pageLength = Math.ceil(blog.length / pageSize);
    return { paginateBlog, pageLength };
  };
  return (
    <div className="row pt-4 px-lg-3">
      <div className="col-xl-1"></div>
      <div className="col-xl-8 col-md-12 px-4">
        <section className="section extra-margins pt-2">
          <h4 class="font-weight-bold">
            <strong>LATESTS NEWS</strong>
          </h4>

          <hr class="red" />
          <div className="row">
            <div className="col-md-12">
              <BlogPosts
                quantityInRow={2}
                blog={getPageData().paginateBlog}
              ></BlogPosts>

              <Pagination
                className="d-flex justify-content-center mb-3"
                count={getPageData().pageLength}
                page={currentPage}
                onChange={handlePageChange}
              />
            </div>
          </div>
        </section>
        <section className="section extra-margins pt-2">
          <h4 class="font-weight-bold">
            <strong>TOP NEWS</strong>
          </h4>

          <hr class="red" />
          <div className="row">
            <div className="col-md-12">
              <BlogPosts quantityInRow={1} blog={blog}></BlogPosts>
            </div>
          </div>
        </section>
        <section className="section extra-margins pt-2">
          <h4 class="font-weight-bold">
            <strong>POPULAR POSTS</strong>
          </h4>

          <hr class="red" />
          <div className="row">
            <div className="col-md-12">
              <BlogPosts quantityInRow={3} blog={blog}></BlogPosts>
            </div>
          </div>
        </section>
      </div>
      <div className="col-xl-3 col-md-12 px-4">
        <h4 class="font-weight-bold">
          <strong>CATEGORIES</strong>
        </h4>

        <hr class="red" />
        <BlogCategory category={category}></BlogCategory>
        <h4 class="font-weight-bold">
          <strong>FEATURED POSTS</strong>
        </h4>

        <hr class="red" />
        <BlogShortPosts posts={blog}></BlogShortPosts>
      </div>
    </div>
  );
};

export default BlogBase;
